<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap justify-center>
      <div class="category-button" md1 v-for="category in cats" :key="category.id" @click="selectCategory(category)" >
        <div :class="{selected: category.id === selectedCategory}">
          <div class="category-title">
            <h4>{{ category.name }}</h4>
          </div>
          <v-flex>
            <v-img :src="category.image" width="50" height="50"/>
          </v-flex>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  name: 'CategorySelect',
  props: ['selectedCategory', 'cats'],
  data: function () {
    return {
    }
  },

  beforeMount: function () {
  },

  methods: {
    selectCategory: function (category) {
      this.$emit('select-category', category)
    }
  }

}
</script>

<style scoped scss>

.category-title {
   text-align: center;
   padding: .1rem;
}

.v-image {
   margin: auto;
}

.category-button {
   margin: .2rem
}

.selected {
  border: 2px solid var(--v-secondary-base);
  border-radius: 4px;
  margin: -2px;
}
</style>
